import {makeObservable} from 'mobx';
import {UserStore} from 'stores/UserStore';
import {AuthStoreBase} from './AuthStoreBase';

export class AuthStore extends AuthStoreBase {
  constructor(userStore: UserStore) {
    super(userStore);
    makeObservable(this, {});
  }

  signIn = async (serverAuthCode?: string) => {
    if (!serverAuthCode) {
      return;
    }

    try {
      const data = await this.authApiManager.signInWithSocialNetworks(
        serverAuthCode,
      );

      await this.saveTokens(data.access_token, data.refresh_token);
    } catch (err) {
      console.log(err);
      throw err;
    }
  };
}
